import loadingOverlayTemplate from './loadingOverlay.html';

angular
   .module('org.saga.loadingOverlay', [])
   .directive('loadingOverlay', [
      function () {
         return {
            restrict: 'E',
            template: loadingOverlayTemplate,
            link: function (scope) {
               scope.isLoading = false;

               scope.$on('loading:show', function () {
                  scope.isLoading = true;
               });

               scope.$on('loading:hide', function () {
                  scope.isLoading = false;
               });
            }
         };
      }
   ]);
